import styled from "styled-components";

export const AcademyNav = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 1%;
  padding: 3%;
  padding-top: 2%;
`;

export const AcademyRow = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: start;
    text-align: start;
    z-index: 1;
`;

export const AcademyTitle = styled.div`
    color: #0071CE;
    font-size: 0.9vw;
    margin-bottom: 5%;
    &:hover {
        opacity: 0.7;
    }
`;

export const AcademyBody = styled.div`
    color: #565656;
    font-size: 0.9vw;
    font-style: normal;
    font-weight: 400;
`;